import { Card, CardContent, Typography } from "@mui/material";

export default function MetricCard({ title, value, subtitle }) {
  return (
    <Card elevation={0} sx={{ border: "1px solid #e0e0e0", borderRadius: "8px", height: "100%" }}>
      <CardContent>
        <Typography variant="h6" color="text.secondary" gutterBottom>
          {title}
        </Typography>
        <Typography variant="h3" component="div">
          {value}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary">
            {subtitle}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}
